import React, { useEffect, Component } from 'react';
import DnDContext from './DnDContext';
import DropArea from './DropArea';
import common_DnDOverContent from './common/DnDOverContent'

const ComponentDropArea = (props, {children}) => {
  const { onDrop, overContent, overContentArg, acceptTypes, customStyle, horizontalDropArea, onMouseInOut, blockOverCon } = props
  // useEffect(() => {
  //   console.log("test")
  // }, [])
  // useEffect(() => {
  //   console.log("acceptTypes is changed", acceptTypes)
  // }, [acceptTypes])

  return (
    <DnDContext>  
      <DropArea 
        onDrop={onDrop}
        overContent={overContent}
        overContentArg={overContentArg}
        acceptTypes={acceptTypes}
        customStyle={customStyle ? customStyle : null}
        horizontalDropArea={horizontalDropArea}
        onMouseInOut={onMouseInOut}
        blockOverCon={blockOverCon} >
        {children}
      </DropArea>
    </DnDContext>
  )
}

const common_overContentArg = {
  minHeight: 15
}

const RenderComponentDropAreaCon = (props, {children}) => {
  const { onDrop, onMouseInOut, DnDOverContent, overContentArg, allowed_types, customStyle, horizontalDropArea, blockOverCon } = props
  return (
    <ComponentDropArea 
      onDrop={onDrop ? onDrop : (e) => {console.log(e)}}
      overContent={DnDOverContent ? DnDOverContent : common_DnDOverContent}
      overContentArg={{...common_overContentArg, ...overContentArg}}
      acceptTypes={allowed_types ? allowed_types : []}
      customStyle={customStyle ? customStyle : null}
      horizontalDropArea={horizontalDropArea}
      onMouseInOut={onMouseInOut}
      blockOverCon={blockOverCon}
    >
      {children}
    </ComponentDropArea>
  )
}

export class RenderComponentDropArea extends Component {
  render() {
    return (
      <RenderComponentDropAreaCon {...this.props} children={this.props.children} />
    )
  }
}

export default ComponentDropArea